import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { modalShow } from 'Containers/Modal/actions';
import Modal from 'Components/Modal';
import withErrorBoundary from 'HOC/ErrorBoundary';

const ModalContainer: FC<any> = () => {
  const Selector = useSelector((selectors: any) => selectors);
  const Dispatch = useDispatch();

  return (
    <>
      {Selector.modal.children && (
        <Modal
          show={Selector.modal.visible}
          title={Selector.modal.title}
          titlePosition={Selector.modal.titlePosition}
          width={Selector.modal.width}
          height={Selector.modal.height}
          onClose={() => Dispatch(modalShow({ visible: false }))}
        >
          {Selector.modal.children}
        </Modal>
      )}
    </>
  );
};

export default withErrorBoundary(ModalContainer);
